import { useState, useEffect } from "react";

let globalOpen = false;
let globalInitialPrompt: string | null = null;

interface WidgetState {
  open: boolean;
  initialPrompt: string | null;
}

const listeners = new Set<(state: WidgetState) => void>();

const notify = () => {
  listeners.forEach((listener) =>
    listener({ open: globalOpen, initialPrompt: globalInitialPrompt })
  );
};

export const prophetWidgetStore = {
  get isOpen() {
    return globalOpen;
  },
  get initialPrompt() {
    return globalInitialPrompt;
  },
  setOpen(open: boolean) {
    globalOpen = open;
    if (!open) {
      globalInitialPrompt = null;
    }
    notify();
  },
  openWithPrompt(prompt: string) {
    globalOpen = true;
    globalInitialPrompt = prompt;
    notify();
  },
  clearInitialPrompt() {
    globalInitialPrompt = null;
    notify();
  },
  subscribe(listener: (state: WidgetState) => void) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};

export function useProphetWidgetStore() {
  const [state, setState] = useState<WidgetState>({
    open: globalOpen,
    initialPrompt: globalInitialPrompt,
  });

  useEffect(() => {
    return prophetWidgetStore.subscribe((newState) => {
      setState(newState);
    });
  }, []);

  return {
    isOpen: state.open,
    initialPrompt: state.initialPrompt,
    setOpen: prophetWidgetStore.setOpen,
    openWithPrompt: prophetWidgetStore.openWithPrompt,
    clearInitialPrompt: prophetWidgetStore.clearInitialPrompt,
  };
}
